export default "__VITE_ASSET__BuK6ExYe__"